import { useState, useEffect, useMemo } from 'react';
import { countryOptions, detectCountry } from './countries';
import { Turnstile } from '@marsidev/react-turnstile';
import { useLang, addTranslations } from './i18n';
import { T, alpha } from './poyais-ui/theme';
import { track, trackOnce, grantAnalytics } from './analytics';

addTranslations({
  'İki aşamalı doğrulama': 'Two-factor authentication',
  'Authenticator uygulamanızdaki 6 haneli kodu girin. Telefonunuza erişemiyorsanız yedek kodlarınızdan birini kullanabilirsiniz.': "Enter the 6-digit code from your authenticator app. If you can't access your phone, use one of your backup codes.",
  'Doğrulama kodu': 'Verification code', 'Doğrulama kodunu girin.': 'Enter the verification code.', 'Doğrula': 'Verify', 'Geri dön': 'Back',
  'Ülke': 'Country', 'Ülke seçin': 'Select country', 'Ülke seçimi zorunludur.': 'Country is required.',
  'Şifre Sıfırlama': 'Password Reset',
  'Sunucuya bağlanılamadı.': 'Could not connect to the server.',
  'Mail gönderildi.': 'Email sent.',
  'Şifre sıfırlama linki': 'A password reset link has been sent to',
  'adresine gönderildi.': 'address.',
  'Giriş Ekranına Dön': 'Back to Login',
  'E-posta adresinizi girin, şifre sıfırlama linki gönderelim.': "Enter your email address and we'll send you a password reset link.",
  'E-Posta': 'Email',
  'Gönderiliyor...': 'Sending...',
  'Sıfırlama Linki Gönder': 'Send Reset Link',
  'E-Posta Doğrulama': 'Email Verification',
  'Doğrulanıyor...': 'Verifying...',
  'E-posta doğrulandı.': 'Email verified.',
  'Doğrulama başarısız.': 'Verification failed.',
  'E-posta doğrulandı!': 'Email verified!',
  'Giriş Yap': 'Log In',
  'Yüksek Güvenlik': 'High Security',
  'Pazarlama verileriniz yüksek düzeyde şifreleme ile korunur.': 'Your marketing data is protected with high-grade encryption.',
  'Akıllı Takip': 'Smart Tracking',
  'Reklam verilerinizi yapay zeka destekli analizlerle izleyin.': 'Track your ad data with AI-powered analytics.',
  'Küçük işletmeler ve solo reklamcılar için.': 'For small businesses and solo advertisers.',
  '2 reklam hesabı': '2 ad accounts',
  'Haftalık AI raporu': 'Weekly AI report',
  'Anomali tespiti': 'Anomaly detection',
  'otomasyon kuralı': 'automation rules',
  'Büyüyen markalar ve dijital ajanslar için.': 'For growing brands and digital agencies.',
  '10 reklam hesabı': '10 ad accounts',
  'Feed Builder + Dynamic Feed': 'Feed Builder + Dynamic Feed',
  'Asistan + RTB House & Criteo': 'Assistant + RTB House & Criteo',
  'Öncelikli destek': 'Priority support',
  'Planınızı seçin. Başlangıç planında ilk 14 gün ücretsiz; dilediğiniz zaman iptal edebilirsiniz.': 'Choose your plan. The Starter plan is free for the first 14 days; cancel anytime.',
  'Planı Seç': 'Choose Plan',
  'EN POPÜLER': 'MOST POPULAR',
  'Hata oluştu.': 'Something went wrong.',
  'Yönlendiriliyor...': 'Redirecting...',
  '14 Gün Ücretsiz Başla': 'Start Free for 14 Days',
  'Şimdi atla, daha sonra seç': 'Skip for now, choose later',
  'Ad, e-posta ve şifre zorunludur.': 'Name, email, and password are required.',
  'Şirket adı zorunludur.': 'Company name is required.',
  'Şifreler eşleşmiyor.': 'Passwords do not match.',
  'Şifre en az 10 karakter olmalı ve en az bir harf ile bir rakam içermelidir.': 'Password must be at least 10 characters and include a letter and a number.',
  'Geçerli bir e-posta adresi giriniz.': 'Please enter a valid email address.',
  'KVKK Aydınlatma Metnini onaylamanız gerekiyor.': 'You must accept the GDPR Privacy Notice.',
  'Kullanım Koşulları ve Veri İşleme Sözleşmesini onaylamanız gerekiyor.': 'You must accept the Terms of Service and Data Processing Agreement.',
  'Kayıt başarısız.': 'Registration failed.',
  'Kayıt başarılı! Giriş yaparak planınızı seçebilirsiniz.': 'Registration successful! Log in to choose your plan.',
  'Yeni hesap oluşturun.': 'Create a new account.',
  'AD': 'FIRST NAME',
  'Adınız': 'Your first name',
  'SOYAD': 'LAST NAME',
  'Soyadınız': 'Your last name',
  'Şirket Adı': 'Company Name',
  "Şirketinizin adı": 'Your company name',
  'Şirket Web Sitesi': 'Company Website',
  'Bir takıma davet edildiniz. Kayıt olduğunuzda otomatik olarak takıma katılacaksınız.': 'You have been invited to a team. You will automatically join the team when you register.',
  'Şifre': 'Password',
  'En az 10 karakter': 'At least 10 characters',
  'Şifre Tekrar': 'Confirm Password',
  'Şifreyi tekrar girin': 'Re-enter your password',
  "ni okudum, kabul ediyorum.": " — I have read and accept it.",
  'Kaydediliyor...': 'Signing up...',
  'Kayıt Ol': 'Sign Up',
  'Zaten hesabım var → Giriş Yap': 'Already have an account → Log In',
  'Zaten bir hesabınız var mı?': 'Already have an account?',
  'Hesap oluşturun': 'Create your account',
  'E-posta ve şifre gerekli.': 'Email and password are required.',
  'Giriş başarısız.': 'Login failed.',
  'Hoş Geldiniz': 'Welcome',
  'Devam etmek için giriş yapın.': 'Log in to continue.',
  'başarıyla abone oldunuz!': 'subscribed successfully!',
  'Plana': 'the plan',
  'planına': 'plan',
  '14 günlük ücretsiz deneme başladı.': 'Your 14-day free trial has started.',
  'Ödeme iptal edildi.': 'Payment canceled.',
  'Dilediğiniz zaman tekrar plan seçebilirsiniz.': 'You can choose a plan again anytime.',
  'E-posta': 'Email',
  'Şifremi Unuttum': 'Forgot Password',
  'Gizle': 'Hide',
  'Göster': 'Show',
  'Giriş yapılıyor...': 'Logging in...',
  'Hesap Oluştur': 'Create Account',
  'Hesaba Giriş Yap': 'Log In to Your Account',
  'Hesabın yok mu?': "Don't have an account?",
  'Kayıt ol': 'Sign up',
});

const API = '/api/v1';
const TURNSTILE_SITE_KEY = process.env.REACT_APP_TURNSTILE_SITE_KEY || '';
const GOLD = T.accent, GOLD_D = T.accentDeep, RED = T.redText, GREEN = T.greenText;

export function getToken() { return localStorage.getItem('poyais_token') || ''; }
export function getUser()  { try { return JSON.parse(localStorage.getItem('poyais_user')||'null'); } catch { return null; } }
export function logout()   {
  localStorage.removeItem('poyais_token');
  localStorage.removeItem('poyais_user');
  window.location.href = '/';
}

function Input({ label, value, onChange, type='text', placeholder='' }:{ label:string; value:string; onChange:(v:string)=>void; type?:string; placeholder?:string }) {
  return (
    <div style={{ marginBottom:16 }}>
      <div style={{ fontSize:11, fontWeight:700, color:'var(--py-text-dim-alt)', marginBottom:6, letterSpacing:'0.1em', textTransform:'uppercase' as const }}>{label}</div>
      <input type={type} value={value} onChange={e=>onChange(e.target.value)} placeholder={placeholder}
        style={{ width:'100%', background:'var(--py-subtle-bg)', border:`1px solid ${T.borderAlt}`, borderRadius:'0.5rem', padding:'12px 16px', fontFamily:'Manrope, sans-serif', fontSize:14, color:T.text, outline:'none', transition:'border-color .15s, box-shadow .15s', display:'block' as const }}
        onFocus={e=>{ e.target.style.borderColor=GOLD; e.target.style.boxShadow=`0 0 0 4px ${alpha(GOLD, 15)}`; }}
        onBlur={e=>{ e.target.style.borderColor=T.borderAlt; e.target.style.boxShadow='none'; }}
        onKeyDown={e=>{ if(e.key==='Enter') (document.getElementById('auth-submit') as HTMLButtonElement)?.click(); }}
      />
    </div>
  );
}

function CountrySelect({ value, onChange, label, placeholder }:{ value:string; onChange:(v:string)=>void; label:string; placeholder:string }) {
  const { lang } = useLang();
  const opts = useMemo(()=>countryOptions(lang),[lang]);
  return (
    <div style={{ marginBottom:11 }}>
      <label style={{ display:'block', fontSize:12, fontWeight:600, color:'rgba(255,255,255,0.85)', marginBottom:4 }}>{label}</label>
      <select value={value} onChange={e=>onChange(e.target.value)}
        style={{ width:'100%', padding:'9px 12px', borderRadius:10, border:'1px solid rgba(255,255,255,0.14)', background:'rgba(255,255,255,0.05)', color: value?'#fff':'rgba(255,255,255,0.5)', fontSize:13, fontFamily:'inherit', outline:'none' }}>
        <option value="" style={{ color:'#000' }}>{placeholder}</option>
        {opts.map(o=><option key={o.code} value={o.code} style={{ color:'#000' }}>{o.name}</option>)}
      </select>
    </div>
  );
}

function AuthInput({ label, value, onChange, type='text', placeholder='', rightSlot, onEnter, compact }:{ label:string; value:string; onChange:(v:string)=>void; type?:string; placeholder?:string; rightSlot?:React.ReactNode; onEnter?:()=>void; compact?:boolean }) {
  return (
    <div style={{ marginBottom: compact?11:18 }}>
      <label style={{ display:'block', fontSize:compact?12:13, fontWeight:600, color:'rgba(255,255,255,0.85)', marginBottom:compact?4:7 }}>{label}</label>
      <div style={{ position:'relative' }}>
        <input type={type} value={value} onChange={e=>onChange(e.target.value)} placeholder={placeholder}
          style={{ width:'100%', padding: rightSlot ? (compact?'9px 40px 9px 12px':'12px 44px 12px 14px') : (compact?'9px 12px':'12px 14px'), borderRadius:10, border:'1px solid rgba(255,255,255,0.14)', background:'rgba(255,255,255,0.05)', fontSize:compact?13:14, color:'#fff', outline:'none', fontFamily:'Manrope, sans-serif', boxSizing:'border-box' as const, transition:'border-color .15s, box-shadow .15s' }}
          onFocus={e=>{ e.target.style.borderColor=GOLD; e.target.style.boxShadow=`0 0 0 3px ${alpha(GOLD, 20)}`; }}
          onBlur={e=>{ e.target.style.borderColor='rgba(255,255,255,0.14)'; e.target.style.boxShadow='none'; }}
          onKeyDown={e=>{ if(e.key==='Enter') onEnter?.(); }}/>
        {rightSlot && <div style={{ position:'absolute', right:12, top:'50%', transform:'translateY(-50%)' }}>{rightSlot}</div>}
      </div>
    </div>
  );
}

function AuthLangSwitcher() {
  const { lang, setLang } = useLang();
  return (
    <div style={{ position:'absolute', top:24, right:24, zIndex:2, display:'flex', background:'rgba(255,255,255,0.05)', border:'1px solid rgba(255,255,255,0.14)', borderRadius:8, padding:2, gap:2 }}>
      {(['tr', 'en'] as const).map(l => (
        <button key={l} type="button" onClick={() => setLang(l)}
          style={{
            padding:'5px 10px', borderRadius:6, border:'none',
            background: lang === l ? GOLD : 'transparent',
            color: lang === l ? T.ink : 'rgba(255,255,255,0.55)',
            fontSize:11.5, fontWeight:800, letterSpacing:'.02em', cursor:'pointer',
            fontFamily:'Manrope, sans-serif',
          }}>
          {l.toUpperCase()}
        </button>
      ))}
    </div>
  );
}

function EyeToggle({ shown, onClick }:{ shown:boolean; onClick:()=>void }) {
  return (
    <button type="button" onClick={onClick} tabIndex={-1} style={{ background:'none', border:'none', cursor:'pointer', padding:0, display:'flex', color:'rgba(255,255,255,0.5)' }}>
      {shown
        ? <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.6"><path d="M3 3l18 18M10.58 10.58a2 2 0 002.83 2.83M9.88 4.24A9.9 9.9 0 0112 4c5 0 9 4 10 8-.36 1.28-1 2.5-1.86 3.55M6.1 6.1C3.92 7.54 2.3 9.62 2 12c1 4 5 8 10 8 1.14 0 2.24-.19 3.26-.54"/></svg>
        : <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.6"><path d="M2 12s3.5-7 10-7 10 7 10 7-3.5 7-10 7-10-7-10-7z"/><circle cx="12" cy="12" r="3"/></svg>
      }
    </button>
  );
}

function ForgotScreen({ onBack }:{ onBack:()=>void }) {
  const { t } = useLang();
  const [email, setEmail]     = useState('');
  const [loading, setLoading] = useState(false);
  const [sent, setSent]       = useState(false);
  const [error, setError]     = useState('');
  const submit = async () => {
    if(!email.trim()) return;
    setLoading(true); setError('');
    try {
      await fetch(`${API}/auth/forgot-password`, { method:'POST', headers:{'Content-Type':'application/json'}, body: JSON.stringify({ email }) });
      setSent(true);
    } catch { setError(t('Sunucuya bağlanılamadı.')); }
    setLoading(false);
  };
  return (
    <div>
      <div style={{ fontSize:11, fontWeight:700, color:'var(--py-text-dim-alt)', letterSpacing:'0.1em', textTransform:'uppercase' as const, marginBottom:8 }}>{t('Şifre Sıfırlama')}</div>
      {sent ? (
        <div style={{ textAlign:'center', padding:'20px 0' }}>
          <div style={{ fontSize:40, marginBottom:12 }}>📧</div>
          <div style={{ fontSize:16, fontWeight:700, color:T.text, marginBottom:8 }}>{t('Mail gönderildi.')}</div>
          <div style={{ fontSize:13, color:'var(--py-text-mid-alt)', lineHeight:1.6, marginBottom:20 }}>{t('Şifre sıfırlama linki')} {email} {t('adresine gönderildi.')}</div>
          <button onClick={onBack} style={{ fontFamily:'Manrope, sans-serif', fontSize:13, fontWeight:700, padding:'9px 16px', borderRadius:11, border:'none', background:GOLD, color:'#fff', cursor:'pointer' }}>{t('Giriş Ekranına Dön')}</button>
        </div>
      ) : (
        <>
          <p style={{ fontSize:13, color:'var(--py-text-mid-alt)', marginBottom:20, lineHeight:1.6 }}>{t('E-posta adresinizi girin, şifre sıfırlama linki gönderelim.')}</p>
          {error && <div style={{ fontSize:12, color:RED, marginBottom:12, padding:'10px 14px', background:'var(--py-red-tint)', borderRadius:'0.5rem', border:`1px solid ${alpha(T.red, 25)}` }}>{error}</div>}
          <Input label={t('E-Posta')} value={email} onChange={setEmail} type="email" placeholder="ornek@domain.com"/>
          <button onClick={submit} disabled={loading} id="auth-submit" style={{ width:'100%', padding:'13px', borderRadius:'0.5rem', border:'none', background:loading?GOLD_D:GOLD, color:'#fff', fontFamily:'Manrope, sans-serif', fontSize:14, fontWeight:700, cursor:loading?'wait':'pointer', marginBottom:10 }}>
            {loading ? t('Gönderiliyor...') : t('Sıfırlama Linki Gönder') + ' →'}
          </button>
          <button onClick={onBack} style={{ width:'100%', padding:'11px', borderRadius:'0.5rem', border:`1px solid ${T.borderAlt}`, background:'transparent', color:'var(--py-text-mid-alt)', fontFamily:'Manrope, sans-serif', fontSize:13, cursor:'pointer' }}>{t('Giriş Ekranına Dön')}</button>
        </>
      )}
    </div>
  );
}

function VerifyScreen({ token, onDone }:{ token:string; onDone:()=>void }) {
  const { t } = useLang();
  const [status, setStatus]   = useState<'loading'|'success'|'error'>('loading');
  const [message, setMessage] = useState('');
  useEffect(() => {
    fetch(`${API}/auth/verify/${token}`)
      .then(r=>r.json())
      .then(d=>{ setStatus('success'); setMessage(d.message||t('E-posta doğrulandı.')); })
      .catch(()=>{ setStatus('error'); setMessage(t('Doğrulama başarısız.')); });
  }, [token]);
  return (
    <div style={{ textAlign:'center', padding:'20px 0' }}>
      <div style={{ fontSize:11, fontWeight:700, color:'var(--py-text-dim-alt)', letterSpacing:'0.1em', textTransform:'uppercase' as const, marginBottom:20 }}>{t('E-Posta Doğrulama')}</div>
      {status==='loading' && <div style={{ color:'var(--py-text-mid-alt)', fontSize:13 }}>{t('Doğrulanıyor...')}</div>}
      {status==='success' && <>
        <div style={{ fontSize:40, marginBottom:12 }}>✅</div>
        <div style={{ fontSize:16, fontWeight:700, color:GREEN, marginBottom:8 }}>{t('E-posta doğrulandı!')}</div>
        <div style={{ fontSize:13, color:'var(--py-text-mid-alt)', marginBottom:20 }}>{message}</div>
        <button onClick={onDone} style={{ fontFamily:'Manrope, sans-serif', fontSize:13, fontWeight:700, padding:'9px 16px', borderRadius:11, border:'none', background:GOLD, color:'#fff', cursor:'pointer' }}>{t('Giriş Yap')} →</button>
      </>}
      {status==='error' && <>
        <div style={{ fontSize:40, marginBottom:12 }}>❌</div>
        <div style={{ fontSize:13, color:RED, marginBottom:20 }}>{message}</div>
        <button onClick={onDone} style={{ fontFamily:'Manrope, sans-serif', fontSize:11, padding:'10px 20px', borderRadius:'0.5rem', border:`1px solid ${T.borderAlt}`, background:'transparent', color:'var(--py-text-mid-alt)', cursor:'pointer' }}>{t('Giriş Ekranına Dön')}</button>
      </>}
    </div>
  );
}

function AuthBackground() {
  // RightPanel'in eskiden sadece kendi (sağ) yarısını kaplayan dekoratif katmanı
  // (radial glow + çapraz çizgiler + üst-alt karartma) — artık tüm sayfayı kaplayan
  // TEK bir arka plan olarak, form paneli ile sağ panel arasındaki flex sınırının
  // görünür bir "çizgi" gibi kesmemesi için ayrı bir bileşene çıkarıldı. Form paneli
  // ve sağ panel içeriği artık kendi arka planlarını çizmiyor, bu katmanın üstünde
  // şeffaf olarak duruyor.
  return (
    <div style={{ position:'absolute', inset:0, zIndex:0, overflow:'hidden', pointerEvents:'none' }}>
      <div style={{ position:'absolute', inset:0, background:'radial-gradient(ellipse at 75% 40%, rgba(201,168,76,0.08) 0%, transparent 55%), radial-gradient(ellipse at 15% 85%, rgba(201,168,76,0.05) 0%, transparent 45%)' }}/>
      <svg style={{ position:'absolute', inset:0, width:'100%', height:'100%', opacity:0.18 }} viewBox="0 0 1440 900" preserveAspectRatio="xMidYMid slice">
        <defs>
          <linearGradient id="lg1" x1="0%" y1="0%" x2="100%" y2="100%">
            <stop offset="0%" stopColor={GOLD} stopOpacity="0"/>
            <stop offset="50%" stopColor={GOLD} stopOpacity="0.7"/>
            <stop offset="100%" stopColor={GOLD} stopOpacity="0"/>
          </linearGradient>
        </defs>
        {[0,1,2,3,4,5,6,7,8,9,10,11].map(i=>(
          <path key={i} d={`M${-160+i*150} 900 Q${360+i*95} ${380-i*30} ${1360+i*55} 0`} stroke="url(#lg1)" strokeWidth="1" fill="none"/>
        ))}
      </svg>
      <div style={{ position:'absolute', inset:0, background:'linear-gradient(to top, rgba(10,15,26,0.55) 0%, transparent 50%, rgba(10,15,26,0.25) 100%)' }}/>
    </div>
  );
}

function RightPanelContent() {
  const { t, lang } = useLang();
  return (
    <div className="login-right-panel" style={{ flex:1, position:'relative', zIndex:1, display:'flex', alignItems:'center', justifyContent:'center', padding:'80px' }}>
      <div style={{ position:'relative', zIndex:10, maxWidth:560 }}>
        <div style={{ marginBottom:28, display:'inline-flex', alignItems:'center', gap:8, padding:'5px 14px', borderRadius:999, background:'rgba(201,168,76,0.12)', border:'1px solid rgba(201,168,76,0.28)' }}>
          <span style={{ width:8, height:8, borderRadius:'50%', background:GOLD, display:'inline-block', animation:'gpulse 2s infinite' }}/>
          <span style={{ fontSize:10, fontWeight:700, color:GOLD, letterSpacing:'0.15em' }}>DIGITAL AUTOMATION</span>
        </div>
        <h2 style={{ fontSize:52, fontWeight:300, color:'#fff', lineHeight:1.15, margin:0, marginBottom:32 }}>
          {lang==='en' ? <>Manage Your Digital Marketing Automation{' '}<br/><span style={{ fontWeight:800, fontStyle:'italic', color:GOLD }}>From One Channel</span></> : <>Dijital Pazarlama Otomasyonunuzu{' '}<br/><span style={{ fontWeight:800, fontStyle:'italic', color:GOLD }}>Tek Bir Kanalla</span>{' '}Yönetin</>}
        </h2>
        <div style={{ display:'grid', gridTemplateColumns:'1fr 1fr', gap:28, marginTop:44 }}>
          <div style={{ display:'flex', alignItems:'flex-start', gap:16 }}>
            <div style={{ width:44, height:44, borderRadius:12, background:'rgba(255,255,255,0.07)', border:'1px solid rgba(255,255,255,0.1)', display:'flex', alignItems:'center', justifyContent:'center', flexShrink:0 }}>
              <svg width="20" height="20" fill="none" stroke={GOLD} strokeWidth="1.5" viewBox="0 0 24 24"><path strokeLinecap="round" strokeLinejoin="round" d="M9 12l2 2 4-4m5.618-4.016A11.955 11.955 0 0112 2.944a11.955 11.955 0 01-8.618 3.04A12.02 12.02 0 003 9c0 5.591 3.824 10.29 9 11.622 5.176-1.332 9-6.03 9-11.622 0-1.042-.133-2.052-.382-3.016z"/></svg>
            </div>
            <div>
              <div style={{ fontWeight:700, color:'#fff', fontSize:14, marginBottom:4 }}>{t('Yüksek Güvenlik')}</div>
              <div style={{ fontSize:13, color:'var(--py-text-dim-alt)', lineHeight:1.5 }}>{t('Pazarlama verileriniz yüksek düzeyde şifreleme ile korunur.')}</div>
            </div>
          </div>
          <div style={{ display:'flex', alignItems:'flex-start', gap:16 }}>
            <div style={{ width:44, height:44, borderRadius:12, background:'rgba(255,255,255,0.07)', border:'1px solid rgba(255,255,255,0.1)', display:'flex', alignItems:'center', justifyContent:'center', flexShrink:0 }}>
              <svg width="20" height="20" fill="none" stroke={GOLD} strokeWidth="1.5" viewBox="0 0 24 24"><path strokeLinecap="round" strokeLinejoin="round" d="M13 7h8m0 0v8m0-8l-8 8-4-4-6 6"/></svg>
            </div>
            <div>
              <div style={{ fontWeight:700, color:'#fff', fontSize:14, marginBottom:4 }}>{t('Akıllı Takip')}</div>
              <div style={{ fontSize:13, color:'var(--py-text-dim-alt)', lineHeight:1.5 }}>{t('Reklam verilerinizi yapay zeka destekli analizlerle izleyin.')}</div>
            </div>
          </div>
        </div>
        <div style={{ marginTop:56, paddingTop:56, borderTop:'1px solid rgba(255,255,255,0.08)' }}>
          <p style={{ fontSize:11, letterSpacing:'0.28em', color:'var(--py-text-mid-alt)', textTransform:'uppercase' as const, margin:0 }}>POYAIS ONE — DIGITAL MARKETING EVOLVED</p>
        </div>
      </div>
    </div>
  );
}


function TrSkip({ onDone }:{ token:string; onDone:()=>void }) {
  useEffect(()=>{ onDone(); },[]);
  return null;
}

function PlanSelection({ token, onSkip, preselectedPlan, clientId }: { token: string; onSkip: () => void; preselectedPlan?: string; clientId?: number|null }) {
  const { t, lang } = useLang();
  const [loading, setLoading] = useState<string|null>(null);
  const [error, setError] = useState('');

  // Eğer plan URL'den geldiyse otomatik checkout başlat
  const autoStarted = useState(false);
  useEffect(() => {
    if(preselectedPlan && (preselectedPlan === 'starter' || preselectedPlan === 'professional') && !autoStarted[0]) {
      autoStarted[1](true);
      selectPlan(preselectedPlan);
    }
  }, []);

  const [apiPlans, setApiPlans] = useState<any>(null);
  useEffect(()=>{ fetch(`${API}/subscription/plans`).then(r=>r.json()).then(d=>setApiPlans(d.plans)).catch(()=>{}); },[]);
  const bl = (id:string, fb:string[]) => (apiPlans?.[id]?.bullets?.[lang==='en'?'en':'tr']) || fb;
  const plans = [
    {
      id: 'starter',
      name: 'Starter',
      price: '$49',
      period: '/mo',
      desc: t('Küçük işletmeler ve solo reklamcılar için.'),
      features: bl('starter', [t('2 reklam hesabı'), 'Google Ads + Meta + GA4', t('Haftalık AI raporu'), t('Anomali tespiti'), `3 ${t('otomasyon kuralı')}`]),
      popular: false,
    },
    {
      id: 'professional',
      name: 'Professional',
      price: '$129',
      period: '/mo',
      desc: t('Büyüyen markalar ve dijital ajanslar için.'),
      features: bl('professional', [t('10 reklam hesabı'), 'Google Ads + Meta + GA4', t('Feed Builder + Dynamic Feed'), t('Asistan + RTB House & Criteo'), t('Öncelikli destek')]),
      popular: true,
    },
  ];

  const selectPlan = async (planId: string) => {
    setLoading(planId); setError('');
    try {
      track('begin_checkout', { plan: planId, provider: 'stripe', currency: 'USD' });
      const res = await fetch(`${API}/subscription/checkout`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Authorization': `Bearer ${token}` },
        body: JSON.stringify({ plan_id: planId, client_id: clientId, locale: lang }),
      });
      const data = await res.json();
      if (!res.ok) { setError(data.detail || t('Hata oluştu.')); setLoading(null); return; }
      window.location.href = data.checkout_url;
    } catch { setError(t('Sunucuya bağlanılamadı.')); setLoading(null); }
  };

  return (
    <div style={{ width: '100%', maxWidth: 680 }}>
      <div style={{ marginBottom: 32, textAlign: 'center' }}>
        <h1 style={{ fontSize: 22, fontWeight: 800, letterSpacing: '0.2em', color: GOLD, textTransform: 'uppercase' as const, margin: 0 }}>POYAIS ONE</h1>
        <p style={{ marginTop: 10, color: 'var(--py-text-mid-alt)', fontSize: 14 }}>{t('Planınızı seçin. Başlangıç planında ilk 14 gün ücretsiz; dilediğiniz zaman iptal edebilirsiniz.')}</p>
      </div>
      {error && <div style={{ fontSize: 12, color: RED, marginBottom: 16, padding: '10px 14px', background: 'var(--py-red-tint)', borderRadius: '0.5rem', border: `1px solid ${alpha(T.red, 25)}` }}>{error}</div>}
      <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 16, marginBottom: 20 }}>
        {plans.map(plan => (
          <div key={plan.id} style={{
            border: plan.popular ? `2px solid ${GOLD}` : `1px solid ${T.borderAlt}`,
            borderRadius: '0.75rem',
            padding: '24px 20px',
            background: plan.popular ? 'var(--py-amber-tint)' : 'var(--py-subtle-bg)',
            position: 'relative' as const,
          }}>
            {plan.popular && (
              <div style={{ position: 'absolute' as const, top: -12, left: '50%', transform: 'translateX(-50%)', background: GOLD, color: '#fff', fontSize: 10, fontWeight: 700, padding: '3px 12px', borderRadius: 99, letterSpacing: '0.1em' }}>{t('EN POPÜLER')}</div>
            )}
            <div style={{ fontSize: 11, fontWeight: 700, color: plan.popular ? GOLD : 'var(--py-text-dim-alt)', textTransform: 'uppercase' as const, letterSpacing: '0.1em', marginBottom: 8 }}>{plan.name}</div>
            <div style={{ marginBottom: 4 }}>
              <span style={{ fontSize: 36, fontWeight: 900, color: plan.popular ? GOLD : T.text }}>{plan.price}</span>
              <span style={{ fontSize: 13, color: 'var(--py-text-dim-alt)' }}>{plan.period}</span>
            </div>
            <p style={{ fontSize: 12, color: 'var(--py-text-mid-alt)', marginBottom: 16, lineHeight: 1.5 }}>{plan.desc}</p>
            <ul style={{ listStyle: 'none', padding: 0, margin: '0 0 20px', display: 'flex', flexDirection: 'column' as const, gap: 8 }}>
              {plan.features.map((f:string) => (
                <li key={f} style={{ fontSize: 12, color: T.text, display: 'flex', gap: 8, alignItems: 'flex-start' }}>
                  <span style={{ color: GOLD, fontWeight: 700, flexShrink: 0 }}>✓</span> {f}
                </li>
              ))}
            </ul>
            <button
              onClick={() => selectPlan(plan.id)}
              disabled={loading !== null}
              style={{
                width: '100%', padding: '12px', borderRadius: '0.5rem', border: 'none',
                background: plan.popular ? GOLD : 'var(--py-ink)',
                color: '#fff', fontFamily: 'Manrope, sans-serif', fontSize: 13, fontWeight: 700,
                cursor: loading !== null ? 'wait' : 'pointer',
                opacity: loading !== null ? 0.7 : 1,
              }}>
              {loading === plan.id ? t('Yönlendiriliyor...') : (apiPlans?.[plan.id]?.trial_days ?? (plan.id === 'starter' ? 14 : 0)) > 0 ? t('14 Gün Ücretsiz Başla') + ' →' : t('Planı Seç') + ' →'}
            </button>
          </div>
        ))}
      </div>
      <div style={{ textAlign: 'center' }}>
        <button onClick={onSkip} style={{ background: 'none', border: 'none', color: 'var(--py-text-dim-alt)', fontSize: 12, cursor: 'pointer', textDecoration: 'underline' }}>
          {t('Şimdi atla, daha sonra seç')}
        </button>
      </div>
      <div style={{ marginTop: 32, textAlign: 'center' }}>
        <p style={{ fontSize: 10, letterSpacing: '0.2em', color: 'var(--py-text-faint)', textTransform: 'uppercase' as const }}>POYAIS DIGITAL © 2026</p>
      </div>
    </div>
  );
}

function RegisterForm({ onLogin, onSuccess, selectedPlan, inviteToken }: { onLogin:()=>void; onSuccess:()=>void; selectedPlan?:string; inviteToken?:string }) {
  const { t, lang } = useLang();
  const [email, setEmail]     = useState('');
  const [pw, setPw]           = useState('');
  const [pw2, setPw2]         = useState('');
  const [showPw, setShowPw]   = useState(false);
  const [showPw2, setShowPw2] = useState(false);
  const [name, setName]       = useState('');
  const [surname, setSurname] = useState('');
  const [companyName, setCompanyName] = useState('');
  const [companyWebsite, setCompanyWebsite] = useState('');
  const [error, setError]     = useState('');
  const [success, setSuccess] = useState('');
  const [loading, setLoading] = useState(false);
  const [regToken, setRegToken] = useState('');
  const [regClientId, setRegClientId] = useState<number|null>(null);
  const [turnstileToken, setTurnstileToken] = useState('');
  const [kvkkAccepted, setKvkkAccepted] = useState(false);
  const [termsDpaAccepted, setTermsDpaAccepted] = useState(false);
  const [country, setCountry] = useState<string>(()=>detectCountry());
  const submit = async () => {
    if(!email || !pw || !name) { setError(t('Ad, e-posta ve şifre zorunludur.')); return; }
    if(!inviteToken && !companyName) { setError(t('Şirket adı zorunludur.')); return; }
    if(!inviteToken && !country) { setError(t('Ülke seçimi zorunludur.')); return; }
    if(pw !== pw2)             { setError(t('Şifreler eşleşmiyor.')); return; }
    if(pw.length < 10 || !/[A-Za-zÇĞİÖŞÜçğıöşü]/.test(pw) || !/[0-9]/.test(pw)) { setError(t('Şifre en az 10 karakter olmalı ve en az bir harf ile bir rakam içermelidir.')); return; }
    if(!email.includes('@'))   { setError(t('Geçerli bir e-posta adresi giriniz.')); return; }
    if(!kvkkAccepted)          { setError(t('KVKK Aydınlatma Metnini onaylamanız gerekiyor.')); return; }
    if(!termsDpaAccepted)      { setError(t('Kullanım Koşulları ve Veri İşleme Sözleşmesini onaylamanız gerekiyor.')); return; }
    setError(''); setLoading(true);
    try {
      const res  = await fetch(`${API}/auth/register`, { method:'POST', headers:{'Content-Type':'application/json'}, body: JSON.stringify({ email, password:pw, name, surname, turnstile_token: turnstileToken, company_name: companyName, country: inviteToken ? undefined : country, company_website: companyWebsite, invite_token: inviteToken, kvkk_accepted: kvkkAccepted, terms_dpa_accepted: termsDpaAccepted }) });
      const data = await res.json();
      if(!res.ok) { setError(data.detail||t('Kayıt başarısız.')); setLoading(false); return; }
      grantAnalytics();
      track('sign_up', { method: 'email', country: country || undefined });
      // Register token ile direkt plan seçimine geç
      if(data.access_token) {
        setRegToken(data.access_token);
        if(data.client_id) {
          setRegClientId(data.client_id);
          localStorage.setItem('poyais_active_client', String(data.client_id));
        }
      } else {
        setSuccess(t('Kayıt başarılı! Giriş yaparak planınızı seçebilirsiniz.'));
        setTimeout(() => { onLogin(); }, 2500);
      }
    } catch { setError(t('Sunucuya bağlanılamadı.')); }
    setLoading(false);
  };
  // Türkiye'den kayıtta ödeme iyzico/TL ile Faturalandırma sayfasından yapılır (Stripe checkout TR hesaplarını reddeder);
  // Hesap ödemesiz Başlangıç'la açılır; plan (Başlangıç'ta 14 gün deneme) Faturalandırma'dan seçilir, bu yüzden Stripe plan seçim ekranı atlanır.
  if(regToken && country==='TR' && !inviteToken) { return <TrSkip token={regToken} onDone={()=>{ localStorage.setItem('poyais_token', regToken); onSuccess(); }} />; }
  if(regToken) return <PlanSelection token={regToken} preselectedPlan={selectedPlan||""} clientId={regClientId} onSkip={() => {
    localStorage.setItem('poyais_token', regToken);
    onSuccess();
  }} />;
  return (
    <div style={{ width:'100%', maxWidth:380 }}>
      <img src="/poyaisone-logo-nav-dark.png" alt="Poyais One" style={{ height:26, width:'auto', marginBottom:16, display:'block' }}/>
      <h1 style={{ fontSize:20, fontWeight:800, color:'#fff', margin:'0 0 4px' }}>{t('Hesap Oluştur')}</h1>
      <p style={{ fontSize:13, color:'rgba(255,255,255,0.5)', margin:'0 0 16px' }}>{t('Hesap oluşturun')}</p>

      <div style={{ display:'grid', gridTemplateColumns:'1fr 1fr', gap:12 }}>
        <AuthInput compact label={`${t('AD')} *`} value={name} onChange={setName} placeholder={t('Adınız')}/>
        <AuthInput compact label={t('SOYAD')} value={surname} onChange={setSurname} placeholder={t('Soyadınız')}/>
      </div>
      {!inviteToken && (
        <div style={{ display:'grid', gridTemplateColumns:'1fr 1fr', gap:12 }}>
          <AuthInput compact label={`${t('Şirket Adı')} *`} value={companyName} onChange={setCompanyName} placeholder={t('Şirketinizin adı')}/>
          <AuthInput compact label={t('Şirket Web Sitesi')} value={companyWebsite} onChange={setCompanyWebsite} placeholder="ornek.com"/>
        </div>
      )}
      {!inviteToken && <CountrySelect value={country} onChange={setCountry} label={`${t('Ülke')} *`} placeholder={t('Ülke seçin')}/>}
      {inviteToken && (
        <div style={{ fontSize:12, color:'rgba(255,255,255,0.6)', marginBottom:11, padding:'10px 12px', background:'rgba(255,255,255,0.05)', borderRadius:10, border:'1px solid rgba(255,255,255,0.14)' }}>
          {t('Bir takıma davet edildiniz. Kayıt olduğunuzda otomatik olarak takıma katılacaksınız.')}
        </div>
      )}
      <AuthInput compact label={`${t('E-Posta')} *`} value={email} onChange={setEmail} type="email" placeholder="ornek@domain.com"/>
      <div style={{ display:'grid', gridTemplateColumns:'1fr 1fr', gap:12 }}>
        <AuthInput compact label={`${t('Şifre')} *`} value={pw} onChange={setPw} type={showPw?'text':'password'} placeholder={t('En az 10 karakter')}
          rightSlot={<EyeToggle shown={showPw} onClick={()=>setShowPw(!showPw)}/>}/>
        <AuthInput compact label={`${t('Şifre Tekrar')} *`} value={pw2} onChange={setPw2} type={showPw2?'text':'password'} placeholder={t('Tekrar girin')}
          rightSlot={<EyeToggle shown={showPw2} onClick={()=>setShowPw2(!showPw2)}/>}/>
      </div>

      {error && <div style={{ background:'rgba(220,60,60,0.12)', border:'1px solid rgba(220,60,60,0.3)', borderRadius:10, padding:'10px 12px', fontSize:12, color:'#ff8a8a', marginBottom:11 }}>{error}</div>}
      {success && <div style={{ background:'rgba(60,180,120,0.1)', border:'1px solid rgba(60,180,120,0.3)', borderRadius:10, padding:'10px 12px', fontSize:12, color:'#5fd99a', marginBottom:11 }}>{success}</div>}

      <label style={{ display:'flex', alignItems:'flex-start', gap:8, marginBottom:11, cursor:'pointer', fontSize:11, color:'rgba(255,255,255,0.55)', lineHeight:1.4 }}>
        <input type="checkbox" checked={kvkkAccepted} onChange={e=>setKvkkAccepted(e.target.checked)}
          style={{ marginTop:2, width:13, height:13, accentColor:GOLD, flexShrink:0 }}/>
        <span>
          {lang==='en' ? (<>
            I have read and accept the <a href="https://poyaisone.com/en/gdpr" target="_blank" rel="noopener noreferrer" style={{ color:GOLD, textDecoration:'underline' }}>GDPR Privacy Notice</a>, and I consent to analytics cookies (Google Analytics) being used to measure and improve the service while I use the platform.
          </>) : (<>
            <a href="https://poyaisone.com/kvkk" target="_blank" rel="noopener noreferrer" style={{ color:GOLD, textDecoration:'underline' }}>KVKK Aydınlatma Metni</a>'ni okudum, kabul ediyorum; platformu kullanırken hizmetin ölçülmesi ve iyileştirilmesi için analiz çerezlerinin (Google Analytics) kullanılmasına izin veriyorum.
          </>)}
        </span>
      </label>

      <label style={{ display:'flex', alignItems:'flex-start', gap:8, marginBottom:11, cursor:'pointer', fontSize:11, color:'rgba(255,255,255,0.55)', lineHeight:1.4 }}>
        <input type="checkbox" checked={termsDpaAccepted} onChange={e=>setTermsDpaAccepted(e.target.checked)}
          style={{ marginTop:2, width:13, height:13, accentColor:GOLD, flexShrink:0 }}/>
        <span>
          <a href={lang==='en' ? 'https://poyaisone.com/en/terms' : 'https://poyaisone.com/kullanim-kosullari'} target="_blank" rel="noopener noreferrer" style={{ color:GOLD, textDecoration:'underline' }}>{lang==='en' ? 'Terms of Service' : 'Kullanım Koşulları'}</a>{lang==='en' ? ' and ' : ' ve '}<a href={lang==='en' ? 'https://poyaisone.com/en/dpa' : 'https://poyaisone.com/veri-isleme-sozlesmesi'} target="_blank" rel="noopener noreferrer" style={{ color:GOLD, textDecoration:'underline' }}>{lang==='en' ? 'Data Processing Agreement' : 'Veri İşleme Sözleşmesi'}</a>{lang==='en' ? ' — I have read and accept them.' : "'ni okudum, kabul ediyorum."}
        </span>
      </label>

      <div style={{ marginBottom:11 }}>
        <Turnstile
          siteKey={TURNSTILE_SITE_KEY}
          onSuccess={(token) => setTurnstileToken(token)}
          onExpire={() => setTurnstileToken('')}
          options={{ theme: 'dark', language: lang }}
          style={{ width: '100%' }}
        />
      </div>

      <button onClick={submit} disabled={loading || !turnstileToken || !kvkkAccepted || !termsDpaAccepted} id="auth-submit"
        style={{ width:'100%', padding:13, background:'#fff', color:T.ink, border:'none', borderRadius:12, fontSize:14, fontWeight:800, cursor:loading?'not-allowed':'pointer', opacity: loading?0.85:1, marginBottom:14, display:'flex', alignItems:'center', justifyContent:'center', gap:8, fontFamily:'Manrope, sans-serif' }}>
        {loading
          ? <><svg style={{ animation:'gspin 1s linear infinite' }} width="16" height="16" fill="none" viewBox="0 0 24 24"><circle cx="12" cy="12" r="10" stroke="rgba(0,0,0,0.2)" strokeWidth="4"/><path fill={T.ink} d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4z"/></svg>{t('Kaydediliyor...')}</>
          : t('Kayıt Ol')
        }
      </button>

      <div style={{ textAlign:'center', fontSize:12, color:'rgba(255,255,255,0.5)' }}>
        {t('Zaten bir hesabınız var mı?')}{' '}
        <button onClick={onLogin}
          style={{ background:'none', border:'none', color:GOLD, fontWeight:700, cursor:'pointer', fontSize:12, textDecoration:'underline', padding:0 }}>
          {t('Giriş Yap')}
        </button>
      </div>
      <div style={{ marginTop:14, fontSize:10, color:'rgba(255,255,255,0.2)', letterSpacing:'0.1em', textTransform:'uppercase' as const }}>POYAIS DIGITAL © 2026</div>
    </div>
  );
}

function planParamEarly(){ try { return new URLSearchParams(window.location.search).get('plan') || 'x'; } catch { return 'x'; } }

export function LoginScreen({ onSuccess }:{ onSuccess:()=>void }) {
  const { t, lang } = useLang();
  const urlParams  = new URLSearchParams(window.location.search);
  const resetToken = urlParams.get('token');
  const planParam  = urlParams.get('plan');
  const inviteParam = urlParams.get('invite');
  const subSuccess = urlParams.get('sub_success');
  if(subSuccess) trackOnce(`sub_${planParamEarly()}`, 'subscription_success', { plan: urlParams.get('plan') || undefined, provider: 'stripe', currency: 'USD' });
  const subCancel  = urlParams.get('sub_cancel');
  const isVerify   = window.location.pathname === '/verify' || window.location.pathname === '/verify-email';
  const isRegister = window.location.pathname === '/register' || (!subSuccess && !subCancel && !!planParam) || !!inviteParam;
  const clearUrl   = () => window.history.replaceState({}, '', '/');
  const planNames: Record<string,string> = { starter: 'Starter', professional: 'Professional' };

  type Screen = 'login'|'register'|'forgot'|'verify';
  const [screen, setScreen] = useState<Screen>(
    isVerify   && resetToken ? 'verify' :
    isRegister               ? 'register' : 'login'
  );

  const [email, setEmail]   = useState('');
  const [pw, setPw]         = useState('');
  const [showPw, setShowPw] = useState(false);
  const [error, setError]   = useState('');
  const [loading, setLoading] = useState(false);
  const [turnstileToken, setTurnstileToken] = useState('');
  // İki aşamalı doğrulama: şifre doğruysa sunucu mfa_token döner, kod ikinci adımda girilir.
  const [mfaToken, setMfaToken] = useState('');
  const [mfaCode, setMfaCode]   = useState('');

  const submitCode = async () => {
    if(!mfaCode.trim()) { setError(t('Doğrulama kodunu girin.')); return; }
    setError(''); setLoading(true);
    try {
      const res  = await fetch(`${API}/auth/login/2fa`, { method:'POST', headers:{'Content-Type':'application/json'}, body: JSON.stringify({ mfa_token: mfaToken, code: mfaCode }) });
      const data = await res.json();
      if(!res.ok) {
        setError(data.detail||t('Giriş başarısız.'));
        if(res.status===401 && /süresi/.test(data.detail||'')) { setMfaToken(''); setMfaCode(''); }
        setLoading(false); return;
      }
      localStorage.setItem('poyais_token', data.token);
      localStorage.setItem('poyais_user',  JSON.stringify(data.user));
      onSuccess();
    } catch { setError(t('Sunucuya bağlanılamadı.')); }
    setLoading(false);
  };

  const submit = async () => {
    if(!email || !pw) { setError(t('E-posta ve şifre gerekli.')); return; }
    setError(''); setLoading(true);
    try {
      const res  = await fetch(`${API}/auth/login`, { method:'POST', headers:{'Content-Type':'application/json'}, body: JSON.stringify({ email, password:pw, turnstile_token: turnstileToken }) });
      const data = await res.json();
      if(!res.ok) { setError(data.detail||t('Giriş başarısız.')); setLoading(false); return; }
      if(data.mfa_required) { setMfaToken(data.mfa_token); setMfaCode(''); setLoading(false); return; }
      localStorage.setItem('poyais_token', data.token);
      localStorage.setItem('poyais_user',  JSON.stringify(data.user));
      onSuccess();
    } catch { setError(t('Sunucuya bağlanılamadı.')); }
    setLoading(false);
  };

  if(screen === 'forgot' || screen === 'verify') {
    return (
      <div style={{ minHeight:'100vh', background:`linear-gradient(135deg,${T.ink} 0%,#2a2d2e 50%,${T.ink} 100%)`, display:'flex', alignItems:'center', justifyContent:'center', fontFamily:'Manrope, sans-serif', padding:'24px 16px' }}>
        <style>{`@import url('https://fonts.googleapis.com/css2?family=Manrope:wght@400;500;600;700;800&display=swap');*{box-sizing:border-box;margin:0;padding:0}`}</style>
        <div style={{ width:'100%', maxWidth:420 }}>
          <div style={{ background:T.surface, borderRadius:20, padding:'36px 32px', boxShadow:'0 20px 60px rgba(0,0,0,0.3)' }}>
            <div style={{ textAlign:'center', marginBottom:24 }}>
              <img src="/poyais-halka.png" alt="Poyais One" width={52} height={52} style={{ display:'inline-block' }}/>
              <div style={{ color:GOLD, fontSize:11, fontWeight:700, letterSpacing:3, marginTop:8, textTransform:'uppercase' as const }}>Poyais One</div>
            </div>
            {screen==='forgot' && <ForgotScreen onBack={()=>{ clearUrl(); setScreen('login'); }}/>}
            {screen==='verify' && <VerifyScreen token={resetToken||''} onDone={()=>{ clearUrl(); setScreen('login'); }}/>}
          </div>
          <div style={{ textAlign:'center', marginTop:20, fontSize:10, color:'rgba(255,255,255,0.2)', letterSpacing:'0.1em', textTransform:'uppercase' as const }}>POYAIS DIGITAL © 2026</div>
        </div>
      </div>
    );
  }

  if(screen === 'register') {
    return (
      <div style={{ minHeight:'100vh', display:'flex', position:'relative', overflow:'hidden', fontFamily:'Manrope, sans-serif', background:'#0a0f1a' }}>
        <style>{`@import url('https://fonts.googleapis.com/css2?family=Manrope:wght@400;500;600;700;800&display=swap');*{box-sizing:border-box;margin:0;padding:0}@keyframes gspin{to{transform:rotate(360deg)}}`}</style>
        <AuthBackground/>
        <div className="login-form-panel" style={{ flex:'1 1 480px', maxWidth:560, minWidth:0, display:'flex', flexDirection:'column', justifyContent:'center', padding:'28px 64px', position:'relative', zIndex:1, overflowY:'auto' }}>
          <AuthLangSwitcher/>
          <div style={{ position:'relative', zIndex:1 }}>
            <RegisterForm onLogin={()=>{ setScreen('login'); setError(''); }} onSuccess={onSuccess} selectedPlan={planParam||""} inviteToken={inviteParam||undefined}/>
          </div>
        </div>
        <RightPanelContent/>
      </div>
    );
  }

  return (
    <div style={{ minHeight:'100vh', display:'flex', position:'relative', overflow:'hidden', fontFamily:'Manrope, sans-serif', background:'#0a0f1a' }}>
      <style>{`@import url('https://fonts.googleapis.com/css2?family=Manrope:wght@400;500;600;700;800&display=swap');*{box-sizing:border-box;margin:0;padding:0}@keyframes gspin{to{transform:rotate(360deg)}}`}</style>
      <AuthBackground/>
      <div className="login-form-panel" style={{ flex:'1 1 480px', maxWidth:560, minWidth:0, display:'flex', flexDirection:'column', justifyContent:'center', padding:'48px 64px', position:'relative', zIndex:1 }}>
        <AuthLangSwitcher/>
        <div style={{ position:'relative', zIndex:1, width:'100%', maxWidth:380 }}>
          <img src="/poyaisone-logo-nav-dark.png" alt="Poyais One" style={{ height:30, width:'auto', marginBottom:44, display:'block' }}/>
          <h1 style={{ fontSize:24, fontWeight:800, color:'#fff', margin:'0 0 8px' }}>{t('Hesaba Giriş Yap')}</h1>
          <p style={{ fontSize:14, color:'rgba(255,255,255,0.5)', margin:'0 0 28px' }}>{t('Devam etmek için giriş yapın.')}</p>

          {subSuccess && (
            <div style={{ marginBottom:18, padding:'14px 16px', background:'rgba(60,180,120,0.1)', border:'1px solid rgba(60,180,120,0.3)', borderRadius:10 }}>
              <div style={{ fontSize:13, fontWeight:700, color:'#5fd99a', marginBottom:4 }}>
                🎉 {lang==='en'
                  ? (planParam && planNames[planParam] ? `You have successfully subscribed to the ${planNames[planParam]} plan!` : 'You have successfully subscribed to the plan!')
                  : `${planParam && planNames[planParam] ? `${planNames[planParam]} planına` : 'Plana'} başarıyla abone oldunuz!`}
              </div>
              {planParam === 'starter' && <div style={{ fontSize:12, color:'#5fd99a' }}>{t('14 günlük ücretsiz deneme başladı.')}</div>}
            </div>
          )}
          {subCancel && (
            <div style={{ marginBottom:18, padding:'14px 16px', background:'rgba(201,168,76,0.1)', border:'1px solid rgba(201,168,76,0.3)', borderRadius:10 }}>
              <div style={{ fontSize:13, fontWeight:700, color:GOLD }}>{t('Ödeme iptal edildi.')}</div>
              <div style={{ fontSize:12, color:GOLD }}>{t('Dilediğiniz zaman tekrar plan seçebilirsiniz.')}</div>
            </div>
          )}

          {mfaToken ? (
          <div>
            <div style={{ fontSize:18, fontWeight:800, color:'#fff', marginBottom:8 }}>{t('İki aşamalı doğrulama')}</div>
            <div style={{ fontSize:13, color:'rgba(255,255,255,0.6)', lineHeight:1.6, marginBottom:20 }}>{t('Authenticator uygulamanızdaki 6 haneli kodu girin. Telefonunuza erişemiyorsanız yedek kodlarınızdan birini kullanabilirsiniz.')}</div>
            <AuthInput label={t('Doğrulama kodu')} value={mfaCode} onChange={setMfaCode} type="text" placeholder="123456" onEnter={submitCode}/>
            {error && <div style={{ background:'rgba(220,60,60,0.12)', border:'1px solid rgba(220,60,60,0.3)', borderRadius:10, padding:'12px 14px', fontSize:13, color:'#ff8a8a', marginBottom:18 }}>{error}</div>}
            <button id="auth-submit" onClick={submitCode} disabled={loading}
              style={{ width:'100%', padding:15, background:'#fff', color:T.ink, border:'none', borderRadius:12, fontSize:15, fontWeight:800, cursor:loading?'not-allowed':'pointer', opacity: loading?0.85:1, marginBottom:16 }}>
              {loading ? '…' : t('Doğrula')}
            </button>
            <button onClick={()=>{ setMfaToken(''); setMfaCode(''); setError(''); }}
              style={{ width:'100%', background:'none', border:'none', color:'rgba(255,255,255,0.6)', fontSize:13, cursor:'pointer', marginBottom:20 }}>
              ← {t('Geri dön')}
            </button>
          </div>
          ) : (<>
          <AuthInput label={t('E-posta')} value={email} onChange={setEmail} type="email" placeholder="ornek@domain.com" onEnter={submit}/>
          <AuthInput label={t('Şifre')} value={pw} onChange={setPw} type={showPw?'text':'password'} placeholder="••••••••" onEnter={submit}
            rightSlot={<EyeToggle shown={showPw} onClick={()=>setShowPw(!showPw)}/>}/>

          <div style={{ marginTop:-10, marginBottom:22 }}>
            <button onClick={()=>{ setScreen('forgot'); setError(''); }}
              style={{ fontSize:13, fontWeight:600, color:GOLD, background:'none', border:'none', cursor:'pointer', padding:0 }}>
              {t('Şifremi Unuttum')}
            </button>
          </div>

          {error && <div style={{ background:'rgba(220,60,60,0.12)', border:'1px solid rgba(220,60,60,0.3)', borderRadius:10, padding:'12px 14px', fontSize:13, color:'#ff8a8a', marginBottom:18 }}>{error}</div>}

          <div style={{ marginBottom:18 }}>
            <Turnstile
              siteKey={TURNSTILE_SITE_KEY}
              onSuccess={(token) => setTurnstileToken(token)}
              onExpire={() => setTurnstileToken('')}
              options={{ theme: 'dark', language: lang }}
              style={{ width: '100%' }}
            />
          </div>

          <button id="auth-submit" onClick={submit} disabled={loading || !turnstileToken}
            style={{ width:'100%', padding:15, background:'#fff', color:T.ink, border:'none', borderRadius:12, fontSize:15, fontWeight:800, cursor:loading?'not-allowed':'pointer', opacity: loading?0.85:1, marginBottom:20, display:'flex', alignItems:'center', justifyContent:'center', gap:8, fontFamily:'Manrope, sans-serif' }}>
            {loading
              ? <><svg style={{ animation:'gspin 1s linear infinite' }} width="16" height="16" fill="none" viewBox="0 0 24 24"><circle cx="12" cy="12" r="10" stroke="rgba(0,0,0,0.2)" strokeWidth="4"/><path fill={T.ink} d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4z"/></svg>{t('Giriş yapılıyor...')}</>
              : t('Giriş Yap')
            }
          </button>

          </>)}

          <div style={{ textAlign:'center', fontSize:13, color:'rgba(255,255,255,0.5)' }}>
            {t('Hesabın yok mu?')}{' '}
            <button onClick={()=>{ setScreen('register'); setError(''); }}
              style={{ background:'none', border:'none', color:GOLD, fontWeight:700, cursor:'pointer', fontSize:13, textDecoration:'underline', padding:0 }}>
              {t('Kayıt ol')}
            </button>
          </div>
        </div>
        <div style={{ position:'relative', zIndex:1, marginTop:32, fontSize:10, color:'rgba(255,255,255,0.2)', letterSpacing:'0.1em', textTransform:'uppercase' as const }}>POYAIS DIGITAL © 2026</div>
      </div>
      <RightPanelContent/>
    </div>
  );
}

export function AuthGate({ children }:{ children: React.ReactNode }) {
  const [loggedIn, setLoggedIn] = useState(!!localStorage.getItem('poyais_token'));
  if(!loggedIn) return <LoginScreen onSuccess={()=>setLoggedIn(true)}/>;
  return <>{children}</>;
}
